
import { defineComponent } from 'vue'
import { theme } from '@/config/styles'

/**
 * Componente para chips clicáveis
 * @prop {String[]} label - texto do botão
 * @prop {String} id - id do botão
 * @prop {String, Number} value - value do botão
 * @prop {Boolean} isChecked - Boolean para saber se o elemento foi clicado.
 * @event chipClicked - Evento Acionado quando el botão é clicado.
 */
const __default__ = defineComponent({
    props: {
        label: String,
        id: String,
        name: String,
        value: [String, Number],
        isChecked: Boolean,
    },
    emits: ['chipClicked'],
    setup(props, context) {
        const clicked = (): void => {
            context.emit('chipClicked')
        }
        return {
            clicked,
            theme,
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "110da28e": (_ctx.theme.colors.primary.mid),
  "68b3afdb": (_ctx.theme.colors.white),
  "2f153880": (_ctx.theme.colors.secondary.mid),
  "8e183014": (_ctx.theme.colors.secondary.middark)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__